import React from "react";
import { Box, Grid, Paper, Stack, Typography, useTheme } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
import PaidIcon from "@mui/icons-material/Paid";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";


const getCard = (isDark) => ({
  p: 2,
  border: `1px solid ${isDark ? "rgba(86,198,98,0.25)" : "#e5f6ee"}`,
  background: isDark
    ? "linear-gradient(180deg,#1c212b 0%,#16241c 100%)"
    : "linear-gradient(180deg,#ffffff 0%,#f7fffb 100%)",
  boxShadow: "0 8px 24px rgba(16,185,129,0.06)",
});

function KPICell({ icon, label, value, accent=false }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Paper elevation={0} sx={getCard(isDark)}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box sx={{ p: 1, borderRadius: 2, bgcolor: accent ? "rgba(16,185,129,0.1)" : "rgba(5,150,105,0.06)" }}>
          {icon}
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">{label}</Typography>
          <Typography variant="h5" sx={{ fontWeight: 800, color: accent ? "primary.main" : "text.primary" }}>
            {value}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
}

export default function KPICards({ totals }) {
  return (
    <Grid container spacing={2} sx={{ mb: 6 }}>
      <Grid item xs={12} sm={6} md={3}><KPICell icon={<InsightsIcon color="success" />} label="Total Staff" value={totals.staff} /></Grid>
      <Grid item xs={12} sm={6} md={3}><KPICell icon={<PaidIcon color="success" />} label="Paid" value={totals.paid} /></Grid>
      <Grid item xs={12} sm={6} md={3}><KPICell icon={<HourglassBottomIcon color="warning" />} label="Unpaid" value={totals.unpaid} /></Grid>
      <Grid item xs={12} sm={12} md={3}><KPICell icon={<AccountBalanceWalletIcon color="success" />} label="Total Net" value={`Rs ${totals.sumNet.toLocaleString()}`} accent /></Grid>
    </Grid>
  );
}